import { TooltipWrapper } from '@components/TooltipWrapper';
import { CloudDownloadIcon } from 'lucide-react';
import { useMemo } from 'react';
import { useFragment } from 'react-relay';
import { archiveFileLinkFragment } from './ArchiveFileLink.relay';
import type { ArchiveFileLinkPropsType } from './types';

export const ArchiveFileLink: React.FC<ArchiveFileLinkPropsType> = (props) => {
  const archiveFileLink = useFragment(archiveFileLinkFragment, props.archiveFileLink);

  const { doctypeheader, header, date, url, text, format, size, icon } = archiveFileLink;

  const subData = useMemo(() => {
    const cleanFormat = format.replace(/^[\w\-]+\/([\w\-]+)$/, '$1');
    return [date, cleanFormat, size].filter(Boolean).join(' | ');
  }, [format, date, size]);

  return (
    <a href={url} className="relative flex items-center cursor-pointer gap-3 justify-start border-b border-[#f2f2f2] py-5 pr-5 no-underline last:border-b-0" download={url} target="_blank" rel="noreferrer">
      <span className="mr-[5px] inline-block w-[60px] min-w-[60px]">{icon ? <img aria-label="file-icon" src={icon} /> : null}</span>

      <span>
        <h4 className="mb-[5px] text-[13px] uppercase tracking-[0.5px] text-accent">{doctypeheader}</h4>
        <h4 className="mb-[5px] text-[13px] uppercase tracking-[0.5px] text-accent">{header}</h4>
        <div className="text-xs leading-normal text-black">
          {text}
          {text ? <br /> : null}
          {subData}
        </div>
      </span>
      <TooltipWrapper text="Download">
        <CloudDownloadIcon className="pointer-events-none size-6 text-gray-400 inline" />
      </TooltipWrapper>
    </a>
  );
};
